'use client';

import { c as _c } from "react/compiler-runtime";
import { ChipName } from '@/domains/pages/ai-proficiency/components/chip-name';
import { cn } from '@/utils/shad';
export type SegmentPillItem = {
  name: string;
  /** Visible label when it differs from the canonical segment key, e.g. translated tenure bands. */
  label?: string;
  valueLabel?: string;
  valueColor?: string;
  valueClassName?: string;
};
export const SEGMENT_PILL_PICKER_CLASS = 'min-w-0 flex-1 border-0 p-0';
type SegmentPillPickerProps = {
  items: SegmentPillItem[];
  selectedName: string;
  onSelect: (name: string) => void;
  className?: string;
};
export function SegmentPillPicker(t0) {
  const $ = _c(12);
  const {
    items,
    selectedName,
    onSelect,
    className
  } = t0;
  if (items.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== className) {
    t1 = cn("no-scrollbar flex flex-nowrap gap-2 overflow-x-auto border-b border-b-lightborder px-6 py-3", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== items || $[3] !== onSelect || $[4] !== selectedName) {
    let t3;
    if ($[6] !== onSelect || $[7] !== selectedName) {
      t3 = item => {
        const isSelected = item.name === selectedName;
        return <button key={item.name} type="button" onClick={() => onSelect(item.name)} className={cn("inline-flex shrink-0 items-center gap-2 rounded-full border px-2.5 py-1 text-xs whitespace-nowrap text-foreground transition-colors", isSelected ? "border-white/60 bg-transparent" : "border-border bg-transparent hover:border-muted-foreground/50")}><ChipName name={item.label ?? item.name} />{item.valueLabel != null ? <span className={cn("font-medium", item.valueClassName)} style={item.valueColor ? {
            color: item.valueColor
          } : undefined}>{item.valueLabel}</span> : null}</button>;
      };
      $[6] = onSelect;
      $[7] = selectedName;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = items.map(t3);
    $[2] = items;
    $[3] = onSelect;
    $[4] = selectedName;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[9] !== t1 || $[10] !== t2) {
    t3 = <div className={t1} data-testid="segment-picker">{t2}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}